import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { CmFormsModule } from '../../../../../../feature-modules/design-system/components/forms/cm-forms.module';
import { PopUpDetails } from '../../../../../../feature-modules/popups/classes/pop-up-details.class';
import { PopupService } from '../../../../../../feature-modules/popups/services/popup.service';
import { CmAlertModule } from '../../../../cm-alert/cm-alert.module';
import { CmModalModule } from '../../../../cm-modal/modal.module';
import { MfaModal } from '../../enums/mfa-modal.enum';

import { ConfigureMfaPopupComponent } from './configure-mfa-popup.component';

@NgModule({
    declarations: [ConfigureMfaPopupComponent],
    imports: [CmAlertModule, CmModalModule, CommonModule, TranslateModule, FormsModule, CmFormsModule, PopoverModule],
    exports: [ConfigureMfaPopupComponent],
})
export class ConfigureMfaPopupModule {
    static popupRegistered: boolean = false;
    constructor(private _popupService: PopupService) {
        if (ConfigureMfaPopupModule.popupRegistered) {
            return;
        }

        ConfigureMfaPopupModule.popupRegistered = true;

        this._popupService.registerPopups({
            [MfaModal.configure]: new PopUpDetails(ConfigureMfaPopupComponent, 'your-account', 'miscellaneous'),
        });
    }
}
